import { useState, useEffect } from "react";
import { useTranslation } from "../contexts/TranslationContext";
import { fetchOpenSourceContent } from "../APIClient/apiClient";

export function useOpenSourceContent() {
  const { currentLanguage, changeLanguage } = useTranslation();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [projects, setProjects] = useState([]);
  const [headerTexts, setHeaderTexts] = useState([]);

  useEffect(() => {
    let isActive = true;

    setTitle("");
    setDescription("");
    setMetaTitle("");
    setProjects([]);
    setHeaderTexts([]);

    fetchOpenSourceContent(currentLanguage).then((data) => {
      if (!isActive) {
        return;
      }
      if (data) {
        setTitle(data.title || "");
        setDescription(data.description || "");
        setMetaTitle(data.metaTitle || "");
        setProjects(Array.isArray(data.projects) ? data.projects : []);
        setHeaderTexts(Array.isArray(data.headerTexts) ? data.headerTexts : []);
      }
    });

    return () => {
      isActive = false;
    };
  }, [currentLanguage]);

  return {
    title,
    description,
    metaTitle,
    projects,
    headerTexts,
    currentLanguage,
    changeLanguage,
  };
}
